import {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import {TimeslotsState} from '../stateTypes';
import {actions} from '../actions';

export const extendWithParentReservationsReducers = (builder: ActionReducerMapBuilder<TimeslotsState>) => {
  builder
    .addCase(actions.fetchParentWorkspaceReservation.pending, (state, action) => {
      const entry = state.parentReservations[action.meta.arg.parentReservationId];
      state.parentReservations[action.meta.arg.parentReservationId] = {
        data: entry?.data ?? null,
        status: 'pending',
        requestId: action.meta.requestId,
      };
    })
    .addCase(actions.fetchParentWorkspaceReservation.fulfilled, (state, action) => {
      state.parentReservations[action.meta.arg.parentReservationId] = {
        data: action.payload,
        status: 'fulfilled',
      };
    })
    .addCase(actions.fetchParentWorkspaceReservation.rejected, (state, action) => {
      state.parentReservations[action.meta.arg.parentReservationId] = {
        data: null,
        errorMessage: action.error.message ?? 'Something went wrong loading parent workspace reservation',
        status: 'rejected',
      };
    });
};
